import axios from '../Api/api';

export default function survey() {
    return new Promise((resolve, reject) => {
        axios.get("/product/getProduct", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
